import { Injectable } from "@angular/core";
import { FormArray, FormControlStatus, FormGroup } from "@angular/forms";
import {
  BaseFpxComponentState,
  BaseFpxFormHelper,
  HttpProviderService,
  IHttpSuccessPayload,
  RoutingInfo,
  BaseFpxChangeHandler,
  BaseFpxControlEventHandler,
  HttpRequest,
  SpinnerService,
  ILookupResponse,
  FpxModal,
  CriteriaQuery
} from "@fpx/core";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { RloapplicationService } from '../rloapplication-service/rloapplication.service';
import { Rloapplication } from '../rloapplication-service/rloapplication.model';
import { RloApplicationSearchFormComponent } from "./rlo-application-search-form.component";
import { MatDialogRef } from "@angular/material/dialog";
import { CommonService } from "src/app/common.service";

export class RloApplicationSearchFormState extends BaseFpxComponentState {
 	showSuggestion : boolean = false;
  customerName: any;
  keyword: string = '';
}


@Injectable()
export class RloApplicationSearchFormHelper extends BaseFpxFormHelper<RloApplicationSearchFormState>{
  search: any;
  criteriaQuery=new CriteriaQuery();
  subscription: Subscription;

   constructor(
    private _httpProvider : HttpProviderService,
    private _router: Router,
    private dialogRef: MatDialogRef<RloApplicationSearchFormComponent>,
    private _rloapplicationService:RloapplicationService,
    public _commonService: CommonService
    )
    {
        super(new RloApplicationSearchFormState());
        this.addChangeHandler('search', this.searchChange);
    }

    private searchChange: BaseFpxChangeHandler = (
      name: string,
      status: FormControlStatus,
      value: any,
      formGroup: FormGroup
    ) => {
      this._rloapplicationService.searchApplied=false;
      this._rloapplicationService.searchValue = '';
      if(value){
        this._rloapplicationService.searchApplied=true;
        this._rloapplicationService.searchValue = value;
      }
        const criteriaQuery=new CriteriaQuery();
        // criteriaQuery.get
        criteriaQuery.setPaginationCriteria('0', 30);
        criteriaQuery.addFilterCritertia("CUSTOMER_NAME","String","Contains",{
          searchText : value ?? ""
        });
        if(this.subscription) {
          this.subscription.unsubscribe();
          this.subscription = null;
        }
        this.subscription = this._rloapplicationService.findAll(criteriaQuery)().subscribe(x=>{
          this.state.customerName = [];
          x.data?.forEach((element,i)=> {
            this.state.customerName.push({
              id:i,
              text: element.customerName
            });
          });
          // console.log(this.state.customerName);
        })
      // }
    };

  override doPreInit(): void {
    if(this._rloapplicationService.searchValue) {
      this._commonService.showSpinner();
      this.state.keyword = this._rloapplicationService.searchValue;
    }
  }


  public override doPostInit(): void {

  }


  public override preSubmitInterceptor(payload: Rloapplication):any {
     // WRITE CODE HERE TO HANDLE
    return payload;
  }

  public override postSubmitInterceptor(response:any): RoutingInfo {
    console.log(response);
    let routingInfo: RoutingInfo = new RoutingInfo();
    routingInfo.setNavigationURL("confirmation");
    if (response.success) {
      routingInfo.setQueryParams({
        transRef: response.success?.body?.fpxdeposit?.depositRef,
        status: "success",
      });
    } else if (response.error) {
      routingInfo.setQueryParams({ status: "failed" });
    }
    return routingInfo;
  }
 //$START_CUSTOMSCRIPT\n
 //$END_CUSTOMSCRIPT\n

closeFilter(action: string = ''){
  if(this._rloapplicationService.searchValue == '') {
    this._rloapplicationService.searchValue='';
    this._rloapplicationService.searchApplied=false;
    this.criteriaQuery.removeFilterCriteria(this._rloapplicationService.applicantNameColumn);
    this._rloapplicationService.criteriaQuery=this.criteriaQuery;
    this.dialogRef.close(1);
  } else this.dialogRef.close();
}
applyFilter(event){
  this.search=event.target.innerHTML;
  this._rloapplicationService.searchValue=this.search;
  this._rloapplicationService.searchApplied=true;
  this.criteriaQuery.addFilterCritertia(this._rloapplicationService.applicantNameColumn, 'String', 'Contains', {
    searchText: this.search,
   });
  this._rloapplicationService.criteriaQuery=this.criteriaQuery;
  this.dialogRef.close(1);
   this._commonService.showSpinner();
}
}
